import * as React from 'react';
import { TextField } from '@fluentui/react';
import { SavingState } from '../api/savingState';
import { parseDecimal } from '../utils/formatter';

export interface FormTextFieldOptions {
    disabled?: boolean;
    numeric?: boolean;
    fixed?: number;
    maxLength?: number;
    onChange?: (newValue: string | number) => void;
}

interface FormTextFieldProps {
    label: string;
    value: string | number;
    onChange?: (newValue: string | number) => void;
    savingState: SavingState;
    options: FormTextFieldOptions;
}

export const FormTextField: React.FC<FormTextFieldProps> = ({ label, value, onChange, savingState, options }) => {
    let textValue = '';
    if (options.numeric) {
        if (options.fixed !== undefined) {
            textValue = ((value as number) || 0).toFixed(options.fixed);
        } else {
            textValue = ((value as number) || 0).toString();
        }
    } else {
        // eslint-disable-next-line no-lonely-if
        if (value !== undefined && value !== null) {
            textValue = value as string;
        }
    }

    return (
        <TextField
            label={label}
            value={textValue}
            type={options.numeric ? 'number' : 'text'}
            disabled={savingState === SavingState.saving || options.disabled}
            maxLength={options.maxLength}
            onChange={(event, newValue) => {
                if (onChange) {
                    onChange(options.numeric ? parseDecimal(newValue) || 0 : newValue || '');
                }
            }}
        />
    );
};
